import React from "react";
import { Link } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";


function Main({activeIndex}) {
  return (
    <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">

      <ListGroup>
        <ListGroup.Item as={Link} action to="/board-of-governors" className={`p-3 ${activeIndex==0 ? " active" : ""}`}>
          <i className="fas fa-chevron-circle-right me-3"></i>
          Board of Governors
        </ListGroup.Item>
        <ListGroup.Item as={Link} action to="/acad-admin" className={`p-3 ${activeIndex==1 ? " active" : ""}`}>
          <i className="fas fa-chevron-circle-right me-3"></i>
          Academic
        </ListGroup.Item>

        <ListGroup.Item as={Link} action to="/senate" className={`p-3 ${activeIndex==2 ? " active" : ""}`}>
          <i className="fas fa-chevron-circle-right me-3"></i>
          Senate
        </ListGroup.Item>

        <ListGroup.Item as={Link} action to="/finance-committee" className={`p-3 ${activeIndex==3 ? " active" : ""}`} >
          <i className="fas fa-chevron-circle-right me-3"></i>
          Finance Committee
        </ListGroup.Item>

        <ListGroup.Item
          as={Link}
          action
          to="/building-and-work-commitee"
          className={`p-3 ${activeIndex==4 ? " active" : ""}`}
        >
          <i className="fas fa-chevron-circle-right me-3"></i>
          B&W Committee
        </ListGroup.Item>
      </ListGroup>
    </Tab.Container>
  );
}
export default Main;
